import type { PieceAction } from '@halvard/rules';
import { useEffect } from 'react';
import type { LocalGameStoreApi } from '../game/store';
import { startBotDriver } from './botDriver';
import type { BotResponse } from './protocol';

/** Plays the bots' turns with a Web Worker, so the board never freezes while a bot thinks. */
export function useBotDriver(store: LocalGameStoreApi): void {
  useEffect(() => {
    const worker = new Worker(new URL('./bot.worker.ts', import.meta.url), { type: 'module' });
    const pending = new Map<number, (response: BotResponse) => void>();
    let nextId = 0;
    worker.onmessage = (event: MessageEvent<BotResponse>) => {
      pending.get(event.data.id)?.(event.data);
      pending.delete(event.data.id);
    };

    const stop = startBotDriver(
      store,
      (request) =>
        new Promise<PieceAction>((resolve, reject) => {
          const id = nextId++;
          pending.set(id, (response) => {
            if (response.ok) resolve(response.choice);
            else reject(new Error(response.error));
          });
          worker.postMessage({ ...request, id });
        }),
    );
    return () => {
      stop();
      worker.terminate();
    };
  }, [store]);
}
